import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, G, Mask, Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AdminIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" title={t`Admin`} fill="none" {...props}>
    <Mask
      id="adminBody"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
      style={{ maskType: "luminance" }}
    >
      <Rect width={24} height={24} fill="#fff" />
      <Circle cx={17.9} cy={17.5} r={5.5} fill="#000" />
    </Mask>
    <G mask="url(#adminBody)" fill="currentColor">
      <Circle cx={10} cy={7.3} r={4.2} />
      <Path d="M10 13.4c-4.4 0-7.7 2.9-7.7 6.7 0 .9.7 1.6 1.6 1.6h12.2c.9 0 1.6-.7 1.6-1.6 0-3.8-3.3-6.7-7.7-6.7z" />
    </G>
    <Mask
      id="adminHub"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
      style={{ maskType: "luminance" }}
    >
      <Rect width={24} height={24} fill="#fff" />
      <Circle cx={17.9} cy={17.5} r={1.35} fill="#000" />
    </Mask>
    <G mask="url(#adminHub)" fill="currentColor">
      <Circle cx={17.9} cy={17.5} r={3.7} />
      {[0, 60, 120, 180, 240, 300].map((rotation) => (
        <Rect
          key={rotation}
          x={16.45}
          y={12.6}
          width={2.9}
          height={2.2}
          rx={0.9}
          transform={`rotate(${rotation} 17.9 17.5)`}
        />
      ))}
    </G>
  </Icon>
);
